export var AppetiteModel;
(function (AppetiteModel) {
    AppetiteModel["Default"] = "default";
    AppetiteModel["TopDownCascade"] = "top_down_cascade";
})(AppetiteModel || (AppetiteModel = {}));
//# sourceMappingURL=appetite-model.js.map